export default "__VITE_ASSET__OGYtASga__"